export default "__VITE_ASSET__Dc7qw8bj__";